import { ReceivablePayload, ReceivablePayloadResponse } from '@types'
import { Service } from '@tino-frontend/adapters'

export class ReceivableService {
  constructor(private readonly http: Service) {}

  getDetail(
    companyId: string,
    payload: ReceivablePayload
  ): Promise<ReceivablePayloadResponse> {
    return this.http.get(`/v1/company/${companyId}/receivables/details`, {
      params: payload,
    })
  }
}
